import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useAuth } from "./use-auth";
import { hasPermission, type PermissionAction } from "./permissions";

export function withPermission<P extends object>(
	Component: React.FC<P>,
	module: string,
	action: PermissionAction,
): React.FC<P> {
	return function PermissionGuard(props: P) {
		const { user, isLoading } = useAuth();
		const navigate = useNavigate();
		const allowed = hasPermission(user, module, action);

		useEffect(() => {
			if (!isLoading && !allowed) {
				navigate({ to: "/", replace: true });
			}
		}, [isLoading, allowed, navigate]);

		if (isLoading || !allowed) {
			return null;
		}

		return <Component {...props} />;
	};
}
